import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

import { useCreateTeam } from '../contexts/teams';
import { EMPTY_VALUES, toPayload, validate } from '../utils/form';
import TeamFields from './fields';

import '../../clients/styles/form.css';

export default function CreateTeamForm() {
    const navigate = useNavigate();
    const createTeam = useCreateTeam();

    const [values, setValues] = useState(EMPTY_VALUES);
    const [errors, setErrors] = useState({});

    const change = (field, value) => {
        setValues(prev => ({ ...prev, [field]: value }));
        setErrors(prev => (prev[field] ? { ...prev, [field]: undefined } : prev));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const found = validate(values);
        if (Object.keys(found).length) {
            setErrors(found);
            return;
        }

        try {
            const created = await createTeam.mutateAsync(toPayload(values));
            toast.success('Equipo creado');
            // Straight to its own screen, which is where the people are added.
            // A team with nobody in it does nothing.
            navigate(`/admin/teams/${created.id}`, { replace: true });
        } catch (err) {
            if (err.fields) setErrors(err.fields);
            else toast.error(err.message || 'No se pudo crear el equipo');
        }
    };

    return (
        <section className="client-form">
            <header className="client-form__header">
                <h2 className="client-form__title">Nuevo equipo</h2>
                <p className="client-form__subtitle">
                    Un equipo agrupa personas para asignarlas a un proyecto. A quiénes
                    incluye se elige después de crearlo.
                </p>
            </header>

            <form onSubmit={handleSubmit} noValidate>
                <div className="client-form__card">
                    <div className="client-form__section">
                        <h3 className="client-form__section-title">Datos del equipo</h3>
                        <p className="client-form__section-text">Cómo se llama y de qué se ocupa.</p>
                    </div>

                    <TeamFields
                        values={values}
                        errors={errors}
                        onChange={change}
                        disabled={createTeam.isPending}
                    />
                </div>

                <div className="client-form__actions">
                    <Link to="/admin/people/equipos" className="client-form__cancel">Cancelar</Link>
                    <button
                        type="submit"
                        className="client-form__submit"
                        disabled={createTeam.isPending}
                    >
                        {createTeam.isPending ? 'Creando...' : 'Crear equipo'}
                    </button>
                </div>
            </form>
        </section>
    );
}
